import {
    GET_ORGANIZATION_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ORGANIZATION_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                userId: action.userId,
                showOrganizationHeader : action.showOrganizationHeader,
                
            }
        default:
            return state
    }
}